export default __webpack_public_path__ + "static/media/sandoog-logo-icon.85398cc4.png";